module.exports = __webpack_public_path__ + "img/crown.b14c5ab2.png";